// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__swedenSans_19d097', '__swedenSans_Fallback_19d097', lucida console, monaco, monospace"},"className":"__className_19d097","variable":"__variable_19d097"};